import { ScrollView } from "devextreme-react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaeCheckBox from "../common_widgets/check-box";
import MdaeList from "../common_widgets/list";
import MdaeSelectBox from "../common_widgets/select-box";
import MdaeRadioGroup from "../common_widgets/radio-group";
import MdaeTreeView from "../common_widgets/tree-view";
import {
  SET_GRID_HEADER_VALUES,
  SET_BELL_CURVE_REPORT_PARAMETER_VALUES,
  SET_WIDGET_INSTANCE,
  bellCurveReportParameterKey,
} from "./reducers/bell-curve-report-parameter-reducer";
import ShowHideTable from "../common_widgets/show-hide-table";

const DetailTemplate: React.FC<any> = (props) => {
  const bellCurveReportParameterEmCategoryList = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer
        .bellCurveReportParameterEmCategoryList
  );
  const bellCurveReportParameterEmDOSList = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer.bellCurveReportParameterEmDOSList
  );
  const targetRadioGroupOptions = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer.targetRadioGroupOptions
  );
  const formatRadioGroupOptions = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer.formatRadioGroupOptions
  );
  const normativeDataSourceList = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer.normativeDataSourceList
  );
  const providerList = useSelector(
    (state: any) => state.bellCurveReportParameterReducer.providerList
  );
  const providerGroupList = useSelector(
    (state: any) => state.bellCurveReportParameterReducer.providerGroupList
  );
  var bellCurveReportParameterWidgetInstances = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer
        .bellCurveReportParameterWidgetInstances
  );
  var bellCurveReportParameterValues = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer.bellCurveReportParameterValues
  );
  var showHideLHSData = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer.showHideLHSData
  );
  const addReportParameterList = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer.addReportParameterList
  );
  const reportParameterAdditionalReportOptionsCookie = JSON.parse(
    localStorage.getItem("ReportParameter_Additional_Report_Options_Cookie")
  );

  const dispatch = useDispatch();

  function getSelectedDosItems() {
    let bellCurveReportParameterEmDOSSelectedItems = [];
    for (let i = 0; i < bellCurveReportParameterEmDOSList.length; i++) {
      for (
        let j = 0;
        j < bellCurveReportParameterEmDOSList[i].items.length;
        j++
      ) {
        for (
          let k = 0;
          k < bellCurveReportParameterEmDOSList[i].items[j].items.length;
          k++
        ) {
          if (bellCurveReportParameterEmDOSList[i].items[j].items[k].selected) {
            bellCurveReportParameterEmDOSSelectedItems.push(
              bellCurveReportParameterEmDOSList[i].items[j].items[k]
            );
          }
        }
      }
    }
    return bellCurveReportParameterEmDOSSelectedItems;
  }

  function onBellCurveReportParameterDosTreeViewInitialized(e) {
    if (!bellCurveReportParameterWidgetInstances.dosTreeView) {
      var bellCurveReportParameterDosTreeViewInstance = e.component;
      dispatch({
        type: SET_WIDGET_INSTANCE,
        data: {
          bellCurveReportParameterWidgetInstances: {
            dosTreeView: bellCurveReportParameterDosTreeViewInstance,
          },
        },
      });
    }
  }

  function TargetRadioGroupTemplate(data) {
    if (data.text == "Single Provider") {
      return (
        <div>
          <div style={{ display: "flex" }}>
            <div className={"target-radio-group-option"}>
              <div className="mdae-data-field-label">{data.text}</div>
            </div>
            <MdaeSelectBox
              id={"pnlBellCurveReportParameterTargetProviderSelectBox"}
              mdaeDropDownBoxTitle={""}
              displayExpr={"providerName"}
              searchEnabled={true}
              placeholder={"Select Provider"}
              width={"400px"}
              dataSource={providerList}
              value={
                providerList?.filter(
                  (x) =>
                    x.providerNpi ===
                    bellCurveReportParameterValues.selectedTargetProviderValue
                      ?.providerNpi
                )[0]
              }
              onValueChanged={(e) => {
                setTimeout(function () {
                  dispatch({
                    type: SET_GRID_HEADER_VALUES,
                    data: {
                      rowIndex: 2,
                      selectedTargetProviderValue: e.value,
                      selectedTargetProviderGroupValue: null,
                    },
                  });
                });
              }}
            ></MdaeSelectBox>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ marginTop: "15px" }}>
          <div style={{ display: "flex" }}>
            <div className={"target-radio-group-option"}>
              <div className="mdae-data-field-label">{data.text}</div>
            </div>
            <div className={"target-radio-group-select-box"}>
              <MdaeSelectBox
                id={"pnlBellCurveReportParameterTargetProviderGroupSelectBox"}
                mdaeDropDownBoxTitle={""}
                displayExpr={"providerGroupName"}
                searchEnabled={true}
                placeholder={"Select Rendering Provider Group"}
                width={"400px"}
                dataSource={providerGroupList}
                value={
                  providerGroupList?.filter(
                    (x) =>
                      x.providerGroupId ===
                      bellCurveReportParameterValues
                        .selectedTargetProviderGroupValue?.providerGroupId
                  )[0]
                }
                onValueChanged={(e) => {
                  setTimeout(function () {
                    dispatch({
                      type: SET_GRID_HEADER_VALUES,
                      data: {
                        rowIndex: 2,
                        selectedTargetProviderGroupValue: e.value,
                        selectedTargetProviderValue: null,
                      },
                    });
                  });
                }}
              ></MdaeSelectBox>
            </div>
          </div>
        </div>
      );
    }
  }

  if (props.data) {
    if (props.data.key == "DOS Range:")
      return (
        <div className={"detail-template"}>
          <MdaeTreeView
            id="pnlBellCurveReportParameterDosList"
            height={150}
            hoverStateEnabled={false}
            showCheckBoxesMode={"normal"}
            animationEnabled={false}
            expandAllEnabled={true}
            items={bellCurveReportParameterEmDOSList}
            expandedExpr={"isExpanded"}
            selectedExpr={"selected"}
            onSelectionChanged={(e) => {
              let SelectedDosItems = getSelectedDosItems();
              dispatch({
                type: SET_GRID_HEADER_VALUES,
                data: {
                  rowIndex: 0,
                  bellCurveReportParameterEmDOSSelectedItems: SelectedDosItems,
                },
              });
            }}
            onInitialized={onBellCurveReportParameterDosTreeViewInitialized}
          />
        </div>
      );
    if (props.data.key == "E&M Categories:")
      return (
        <div><ShowHideTable
          LHSList={showHideLHSData}
          RHSList={bellCurveReportParameterEmCategoryList}
          widgetKey={bellCurveReportParameterKey.bellCurveReportParameterEMCategoryKey}
          displayExpr={"text"}
          rowIndex={1} /></div>
      );
    if (props.data.key == "Define Target:")
      return (
        <div className={"detail-template"}>
          <MdaeRadioGroup
            id="pnlBellCurveReportParameterTargetRadioGroup"
            items={targetRadioGroupOptions}
            width={"500px"}
            valueExpr={"value"}
            itemRender={TargetRadioGroupTemplate}
            value={bellCurveReportParameterValues.selectedTargetType}
            onValueChanged={(e) => {
              dispatch({
                type: SET_GRID_HEADER_VALUES,
                data: {
                  rowIndex: 2,
                  selectedTargetType: e.value,
                  selectedTargetProviderGroupValue: null,
                  selectedTargetProviderValue: null,
                },
              });
            }}
          />
        </div>
      );
    if (props.data.key == "Additional Report Options:")
      return (
        <div><ShowHideTable
          LHSList={reportParameterAdditionalReportOptionsCookie != undefined ? reportParameterAdditionalReportOptionsCookie.hideItems : addReportParameterList}
          RHSList={reportParameterAdditionalReportOptionsCookie != undefined ? reportParameterAdditionalReportOptionsCookie.showItems : []}
          widgetKey={bellCurveReportParameterKey.bellCurveReportParameterAdditionalReportOptionKey}
          displayExpr={"reportParm"}
          rowIndex={3} /></div>
      );
    if (props.data.key == "Export format:")
      return (
        <div
          id="pnlBellCurveReportParameterFormatRadioGroup"
          className={"detail-template"}
        >
          <MdaeRadioGroup
            id="pnlBellCurveReportParameterFormatRadioGroup"
            items={formatRadioGroupOptions}
            width={"500px"}
            valueExpr={"value"}
            layout={"horizontal"}
            value={
              bellCurveReportParameterValues.exportFormatForLongRunningReports
            }
            mdaeDataUpdaterConfig={[
              {
                actionType: SET_BELL_CURVE_REPORT_PARAMETER_VALUES,
                reducerName: "bellCurveReportParameterReducer",
                widgetOptionBindings: {
                  value:
                    "bellCurveReportParameterValues.exportFormatForLongRunningReports",
                },
              },
            ]}
          />
        </div>
      );
  } else {
    return null;
  }
};
export default DetailTemplate;
